/* eslint-disable @typescript-eslint/no-inferrable-types,@typescript-eslint/default-param-last */
import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import { FontSizeModeEnum } from './types';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';

const FontSizeSwitcherElement = withDynamicBlogEditorPluginHydration()(dynamicEditorComponent(() =>
  import('./components/FontSizeSwitcherElement').then((mod) => mod.FontSizeSwitcherElement),
));

export const renderElementFontSizeSwitcher = (fontSizeMode: FontSizeModeEnum, isHideParagraphIndex: boolean = false) => {
  return (props: RenderElementProps) => {
    return <FontSizeSwitcherElement fontSizeMode={fontSizeMode} isHideParagraphIndex={isHideParagraphIndex} {...props} />;
  };
};
